var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TicketBoxAdvanceSelect',{attrs:{"data":_vm.ticketBoxList,"selectedData":_vm.compact([_vm.selectedId])},on:{"confirm":_vm.onConfirm,"close":function($event){return _vm.$emit('close')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }